import EvaluationFilter from './EvaluationFilter';
import {connect} from 'react-redux';

const mapStateToProps = state => state;

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationFilter);
